const validation = response => {
  if (process.env.NODE_ENV === "development") console.log(response);

  if (response.status >= 200 && response.status < 300) {
    return {
      status: true,
      data: response.data
    };
  }

  if (response.status >= 400 && response.status < 500) {
    let errors_list = [];

    for (const [key, value] of Object.entries(response.data)) {
      errors_list.push(
        key == "non_field_errors" || key == "details" || key == "detail"
          ? `${response.data[key]}`
          : `${key}: ${response.data[key]}`
      );
    }

    return {
      status: false,
      data: errors_list
    };
  }

  return {
    status: false,
    data: ["Lo Sentimos, en este momento estamos presentando problemas."]
  };
};

export default validation;
